<template>
    <div>
        <Panel
            :title="$t('Outbound Presentation CLIs')"
            :delete-button="selected.length > 0"
            :page="page"
            :total-rows="clis.length"
            @change="changePage"
        >
            <CicCsvImport
                :label="$t('CSV Import File')"
                :help-text="$t('Presentation CLI imports do not remove any existing CLI')"
                input-id="import_clis"
                class="table-header-row"
                @change="onImport"
            />

            <table id="accesspoints_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('CLI') }}</th>
                        <th class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="cli in pageItems">
                        <td>{{ cli }}</td>
                        <td>
                            <IconButton :title="$t('Delete CLI')" icon="remove-icon" @click="handleDelete(cli)" />
                        </td>
                    </tr>
                    <tr>
                        <td><CicTextbox :value="newCLI" :max-length="255" @input="(val) => (newCLI = val)" /></td>
                        <td>
                            <IconButton v-if="newCLI" :title="$t('Save CLI')" icon="add-icon" @click="addCli" />
                        </td>
                    </tr>
                </tbody>
            </table>

            <template #footer>
                <TextButton id="popup_export" :style="{ marginLeft: '5px' }">
                    <a :href="link" :download="`${$t('Outbound Presentation CLIs').replace(/\s/g, '')}.csv`">
                        {{ $t('Export') }}</a
                    >
                </TextButton>
            </template>
        </Panel>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import File from '@/mixins/File';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, save, load } from '@/utils/Http';
    import { showValidationMessage } from '@/utils/Notification';
    import { IconButton, TextButton } from '@/components/controls/index';
    import { CicCsvImport, CicTextbox } from '@/components/inputs/index';

    export default {
        name: 'PresentationCLIs',
        components: {
            CicCsvImport,
            TextButton,
            CicTextbox,
            Panel,
            IconButton,
        },
        mixins: [TableUtils, File],
        data() {
            return {
                clis: [],
                page: 1,
                imported: [],
                selected: [],
                newCLI: '',
            };
        },
        computed: {
            link() {
                let csvContent = 'data:text/csv;charset=utf-8,' + [[this.$t('CLI')]].concat(this.clis).join('\n');
                return encodeURI(csvContent);
            },
            pageItems() {
                return this.clis.slice((this.page - 1) * 20, this.page * 20);
            },
        },
        created() {
            this.loadTable();
        },
        methods: {
            addCli() {
                if (!/^\+?\d+$/.test(this.newCLI.trim())) {
                    showValidationMessage('Invalid CLI');
                    return;
                }
                if (this.clis.includes(this.newCLI.trim())) {
                    showValidationMessage('The CLI already exists');
                    return;
                }

                save('cli/add', { cli: this.newCLI.trim() }, this.loadTable);
            },

            changePage(page) {
                this.page = page;
            },

            handleDelete(cli) {
                if (confirm(this.$t('Are you sure you want to delete the selected CLI?'))) {
                    deleteItems('cli/delete', { cli }, this.loadTable);
                }
            },

            loadTable() {
                this.selected = [];
                this.newCLI = '';
                load('clis/get', {}, ({ clis }) => {
                    this.clis = clis;
                });
            },

            onImport(content) {
                const headerRow = content[0] === this.$t('CLI');
                const rows = headerRow ? JSON.stringify(content.slice(1, content.length)) : JSON.stringify(content);

                save('clis/import', { rows, headerRow }, this.loadTable);
            },
        },
    };
</script>
